import { ContactFormFields } from './types'
import { ContactInfoFields } from './utils'
import { DisplayToggle } from '../components/DisplayToggle'
import { FC } from 'react'
import { UseFormReturn } from 'react-hook-form'

export const ContactInfoDisplayToggle: FC<{
  setValue: UseFormReturn<ContactFormFields>['setValue']
  displayType: string
}> = ({ setValue, displayType }) => {
  return (
    <DisplayToggle
      onChange={(_e, type) => {
        setValue(ContactInfoFields.DISPLAY_TYPE, type)
      }}
      displayOptions={[
        { title: 'Circle', value: 'widget' },
        { title: 'Floating', value: 'default' }
      ]}
      displayType={displayType}
      name="icon-style-toggle"
      title="Icon Style"
    />
  )
}
